<table *ngIf='showTable ; else errorTextField' mat-table [dataSource]="tableData" class="details-screen-table scrollable-table">
  <ng-container matColumnDef="cardNumber">
    <th mat-header-cell *matHeaderCellDef> Pasnummer </th>
    <td mat-cell *matCellDef="let data"> {{data.cardNumber ? data.cardNumber : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="sequenceNumber">
    <th mat-header-cell *matHeaderCellDef> Volgnummer </th>
    <td mat-cell *matCellDef="let data"> {{data.sequenceNumber ? data.sequenceNumber : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef> Status </th>
    <td mat-cell *matCellDef="let data"> {{data.status ? data.status : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="creationDate">
    <th mat-header-cell *matHeaderCellDef> Datum aanvraag </th>
    <td mat-cell *matCellDef="let data"> {{data.creationDate ? data.creationDate : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="registrationDataPreparatorDateTime">
    <th mat-header-cell *matHeaderCellDef> Naar processor </th>
    <td mat-cell *matCellDef="let data"> {{data.registrationDataPreparatorDateTime ? data.registrationDataPreparatorDateTime : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="notificationDataPreparatorDateTime">
    <th mat-header-cell *matHeaderCellDef> Retour processor </th>
    <td mat-cell *matCellDef="let data"> {{data.notificationDataPreparatorDateTime ? data.notificationDataPreparatorDateTime : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="registrationPassFactoryDateTime">
    <th mat-header-cell *matHeaderCellDef> Naar personalisator </th>
    <td mat-cell *matCellDef="let data"> {{data.registrationPassFactoryDateTime ? data.registrationPassFactoryDateTime : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="notificationPassFactoryDateTime">
    <th mat-header-cell *matHeaderCellDef> Retour personalisator </th>
    <td mat-cell *matCellDef="let data"> {{getNotificationDateTime(data)}} </td>
  </ng-container>

  <ng-container matColumnDef="replacementCardSequenceNumber">
    <th mat-header-cell *matHeaderCellDef> Vervangt volgnummer </th>
    <td mat-cell *matCellDef="let data"> {{data.replacementCardSequenceNumber ? data.replacementCardSequenceNumber : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="requestReason">
    <th mat-header-cell *matHeaderCellDef> Reden bestelling </th>
    <td mat-cell *matCellDef="let data"> {{data.requestReason ? data.requestReason : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="secureElementType">
    <th mat-header-cell *matHeaderCellDef> SE Type </th>
    <td mat-cell *matCellDef="let data"> {{data.secureElementType ? data.secureElementType : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="secureElementId">
    <th mat-header-cell *matHeaderCellDef> SE-ID </th>
    <td mat-cell *matCellDef="let data"> {{data.secureElementId ? data.secureElementId : emptyValuePlaceholder}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>

</table>
<ng-template #errorTextField>
  <div class="error-text">
    {{errorText}}
  </div>
</ng-template>
